import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UploadEngagementMetricsForGenReport.graphql';
import { Mutation, MutationuploadEngagementMetricsForGenReportArgs } from '../../__generated__/globalTypes';

export const useUploadEngagementMetricsForGenReportMutation = (
  options?: MutationHookOptions<Mutation, MutationuploadEngagementMetricsForGenReportArgs>
) => {
  const [callUploadEngagementMetricsForGenReport, result] = useMutation<
    Mutation,
    MutationuploadEngagementMetricsForGenReportArgs
  >(MUTATION, options);

  return { callUploadEngagementMetricsForGenReport, ...result };
};

export type UploadEngagementMetricsForGenReportMutationFunction = Mutation['uploadEngagementMetricsForGenReport'];
